export default __webpack_public_path__ + "static/media/88t.6eebcd37.jpg";